<con-app [accountLabel]="account.name" [accountIcon]="accountIcon" [links]="links">
  <router-outlet></router-outlet>
</con-app>
